import { useEffect, useState } from 'react';

const overrides = new Map<string, string>();
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => l());
}

export function setBreadcrumbOverride(path: string, label: string) {
  overrides.set(path, label);
  notify();
}

export function clearBreadcrumbOverride(path: string) {
  overrides.delete(path);
  notify();
}

export function useBreadcrumbOverrides(): Map<string, string> {
  const [, bump] = useState(0);
  useEffect(() => {
    const cb = () => bump((n) => n + 1);
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  }, []);
  return overrides;
}
